import type { Accent } from '../types/accent'

export const accentBg: Record<Accent, string> = {
  pine: 'bg-pine',
  olive: 'bg-olive',
  rust: 'bg-rust',
  ember: 'bg-ember',
  navy: 'bg-navy',
  charcoal: 'bg-charcoal',
}

export const accentText: Record<Accent, string> = {
  pine: 'text-pine',
  olive: 'text-olive',
  rust: 'text-rust',
  ember: 'text-ember',
  navy: 'text-navy',
  charcoal: 'text-charcoal',
}

export const accentBorder: Record<Accent, string> = {
  pine: 'border-pine',
  olive: 'border-olive',
  rust: 'border-rust',
  ember: 'border-ember',
  navy: 'border-navy',
  charcoal: 'border-charcoal',
}
